<div class="text-center text-white mt-10">
    <img src="assets/images/failure.png" alt="Page Not Found" class="img-fluid" width="60">
    <h2 class="text-danger mt-3">Access Denied</h2>
    <p class="mt-3">You are not authorized to view this page. <br> Please click on the below button to go back to dashboard.</p>
    <p class="mt-4"><a routerLink="/dashboard" class="btn btn-success btn-sm">Return to Dashboard</a></p>
</div>
